import axios from "axios";
import { BASE_URL } from "./apiPaths";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // aumente para 30s ou mais
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

//request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");
    // const accessToken =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzU0NTI3NjQxLCJpYXQiOjE3NTQ1MjA0NDEsImp0aSI6ImZlY2EyODc1NmUxZDRhMGI5ZjhlYzVkNDMzYjI0NjA1IiwidXNlcl9pZCI6MX0.sDnLpfShCBxw5W6YXWTcL7wXO7YL9lEq1Aqk83tOBXw";
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);

    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem("token");

        // Opcional: redireciona só se não estiver já na página de login
        if (window.location.pathname !== "/signin") {
          window.location.href = "/signin";
        }
      } else if (error.response.status === 500) {
        console.log("Server error please try again later.");
      }
    } else if (error.code === "ECONNABORTED") {
      console.log("Request timeout.Please try again.");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
